import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { SESSION_HOME_EVENT } from './sessionNavigation';

/** Remounts the current screen when a role or organisation switch opens its home. */
export function useSessionNavigation(): number {
  const navigate = useNavigate();
  const [epoch, setEpoch] = useState(0);

  useEffect(() => {
    const onHome = (event: Event) => {
      const path = (event as CustomEvent<{ path?: string }>).detail?.path;
      if (!path) return;
      event.preventDefault();
      navigate(path, { replace: true });
      setEpoch(value => value + 1);
    };
    window.addEventListener(SESSION_HOME_EVENT, onHome);
    return () => window.removeEventListener(SESSION_HOME_EVENT, onHome);
  }, [navigate]);

  return epoch;
}
